import { useEffect, useState } from "react";
import { SocketURL } from "../ApiService/Axios/Index";
import { getLocalStorageItem } from "../Utils/Index";
import { io } from "socket.io-client";
import { triggerSnackbar } from "../Services/NotificationService";

const UseSocket = (path, setState = () => {}, apiCall = () => {}) => {
  const [socket, setSocket] = useState(null);
  console.log({ socket });
  useEffect(() => {
    const socketInstance = io(`${SocketURL}/${path}`, {
      auth: {
        token: getLocalStorageItem("access_token"),
      },
    }); // Replace with your server URL

    setSocket(socketInstance);

    return () => {
      socketInstance.disconnect();
    };
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    // Listen for 'connect' event
    if (socket && getLocalStorageItem("access_token")) {
      socket.on("notification_dashboard", (data) => {
        const audio = new Audio("/notification.mpeg"); // Ensure the path is correct
        audio?.play().catch((err) => console.log(err, "Playback error"));
        triggerSnackbar("New order arrived", "success");
        setState(data?.data);
      });
      socket.on("order_receive", (data) => {
        const audio = new Audio("/notification.mpeg"); // Ensure the path is correct
        audio?.play().catch((err) => console.log(err, "Playback error"));
        apiCall();
        triggerSnackbar("New message arrived", "success");
      });
      socket.on("notification_AssignPerson ", (data) => {
        const audio = new Audio("/notification.mpeg"); // Ensure the path is correct
        audio?.play().catch((err) => console.log(err, "Playback error"));
        apiCall();
        triggerSnackbar("New message arrived", "success");
      });
      socket.on("receive_order_restaurant", (data) => {
        const audio = new Audio("/notification.mpeg"); // Ensure the path is correct
        audio?.play().catch((err) => console.log(err, "Playback error"));
        apiCall();
        triggerSnackbar("New message arrived", "success");
      });
    }
    //eslint-disable-next-line
  }, [socket]);
  return { socket };
};

export default UseSocket;
